import { fallbackAssumption } from '../fallbacks.js';
import { formatAnswers, formatLocation, formatPeriod, formatSchedule } from '../format.js';
import { buildInfluenceBlock, OPERATION_GUARDRAILS } from '../influence.js';
import type { PromptRequest, PromptSourceBundle } from '../types.js';
import { baseRequest, type CompilerSpec } from './base.js';
import { buildWorldContext } from '../filters.js';

const SPEC: CompilerSpec = {
  purpose: 'assumption',
  maxTier: 0,
  allowedTiers: [0],
  budget: { inputTokens: 900, outputTokens: 400 },
  provider: 'deepseek',
};

export function compileAssumption(
  source: PromptSourceBundle,
  fieldPath: string,
  missingFieldLabel: string,
): PromptRequest {
  const world = buildWorldContext(source);
  const confirmed = Object.entries(world.answers)
    .filter(([, a]) => a.status === 'confirmed')
    .map(([id]) => id);
  const influence = buildInfluenceBlock('assumption', world);
  const header = [
    'PURPOSE: assumption',
    OPERATION_GUARDRAILS.assumption,
    `PRESERVE_CONFIRMED: ${confirmed.join(', ') || '(none)'}`,
    influence.text,
  ].join('\n');

  const tier0 = [
    `MISSING_FIELD: ${fieldPath} (${missingFieldLabel})`,
    `LOCATION: ${formatLocation(world)}`,
    `PERIOD: ${formatPeriod(world.timePeriod)}`,
    `SCHEDULE: ${formatSchedule(world.schedule)}`,
    `ACCEPTED_ANSWERS:\n${formatAnswers(world.answers)}`,
  ].join('\n');

  return baseRequest(
    source,
    SPEC,
    { tier0 },
    [],
    [],
    [],
    header,
    {
      local: () => fallbackAssumption(fieldPath),
      retryOnValidationError: true,
      noKeyUsesLocal: true,
    },
  );
}

export const assumptionMaxTier = SPEC.maxTier;
